// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type ArrowRightIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from arrow-right.svg
 */
export default function ArrowRightIcon(props: ArrowRightIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="ArrowRightIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="m9.613 3.21.094.083 4 4a1 1 0 0 1 .083 1.32l-.083.094-4 4a1 1 0 0 1-1.497-1.32l.083-.094L10.585 9H3a1 1 0 0 1-.117-1.993L3 7h7.585L8.293 4.707a1 1 0 0 1-.083-1.32l.083-.094a1 1 0 0 1 1.32-.083"
        />
      </g>
    </svg>
  );
}
